export const MemberStatus = {
    PENDING: 'pending',
    ACTIVE: 'active',
    DEACTIVATED: 'deactivated',
};
export var MemberEncryptionType;
(function (MemberEncryptionType) {
    MemberEncryptionType["ZERO_KNOWLEDGE"] = "zeroKnowledge";
    MemberEncryptionType["NON_ZERO_KNOWLEDGE"] = "nonZeroKnowledge";
})(MemberEncryptionType || (MemberEncryptionType = {}));
export var MemberScimStatus;
(function (MemberScimStatus) {
    MemberScimStatus["NO_SCIM"] = "noScim";
    MemberScimStatus["ACTIVE"] = "active";
    MemberScimStatus["DEACTIVATED"] = "deactivated";
})(MemberScimStatus || (MemberScimStatus = {}));
